import { render, staticRenderFns } from "./DocsDetailReturns.vue?vue&type=template&id=3eb7f9dc&"
import script from "./DocsDetailReturns.vue?vue&type=script&lang=js&"
export * from "./DocsDetailReturns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports